import lodash from 'lodash';

const initialState = {
    $lastUpdateTime: undefined,
    page: 0,
    // Rows per page || Limit
    rpp: 25,
    // Or skip
    offset: 0,
    rppOptions: [25, 50, 100],
};

export const buildPagination = (options) => {
    const $lastUpdateTime = Date.now();

    return lodash.merge({}, initialState, options, { $lastUpdateTime });
};



// WEBPACK FOOTER //
// ./src/common/factories/pagination.js